export const GET_GALLERY_REQUEST = 'GET_GALLERY_REQUEST'
export const GET_GALLERY_SUCCESS = 'GET_GALLERY_SUCCESS'
export const GET_GALLERY_FALIURE = 'GET_GALLERY_FALIURE'
export const UPLOAD_REQUEST = 'UPLOAD_REQUEST'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const UPLOAD_FALIURE = 'UPLOAD_FALIURE'
export const UPLOAD_VIDEO_REQUEST = 'UPLOAD_VIDEO_REQUEST'
export const UPLOAD_VIDEO_SUCCESS = 'UPLOAD_VIDEO_SUCCESS'
export const UPLOAD_VIDEO_FALIURE = 'UPLOAD_VIDEO_FALIURE'
